import React, { useState } from "react";

import Grid from "@mui/material/Unstable_Grid2";
import { Paper } from "@mui/material";
import ReceiptsSearch from "../components/ReceiptSearchDoctors";
import ReceiptTable from "../components/ReceiptTableDoctors";

const ReceiptsViewDoctors = () => {
	const [receiptDatas, setReceiptDatas] = useState([]);
	const [page, setPage] = useState(1);
	const [pageCount, setPageCount] = useState(1);
	const [labNames, setLabNames] = useState([]);

	const updateData = (data, count, labs) => {
		setPageCount(count);
		setReceiptDatas(data);
		setLabNames(labs);
	};
	const getPage = (p) => setPage(p);

	return (
		<Paper sx={{ maxWidth: "1400px", p: 4 }}>
			<Grid container spacing={4}>
				<Grid xs={12}>
					<ReceiptsSearch
						page={page}
						rowCount={15}
						updateReceiptData={updateData}
					/>
				</Grid>
				<Grid xs={12}>
					<ReceiptTable
						data={receiptDatas}
						getPage={getPage}
						pageCount={pageCount}
						labNames={labNames}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default ReceiptsViewDoctors;
